import { Helmet } from 'react-helmet-async'

type JsonLdProps = {
  data: unknown | unknown[]
}

export default function JsonLd({ data }: JsonLdProps) {
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  )
}
